import { useGetContractor } from 'entities/profile';
import { getDayName, getFormattedDate, getPendingDate } from 'shared/lib/format';

import { AllowedTimezones, getTimezone } from './timezones';

export const timeZonesLegends = {
  [AllowedTimezones.AMERICA_NEW_YORK]: '(ET)',
  [AllowedTimezones.AMERICA_CHICAGO]: '(CT)',
  [AllowedTimezones.AMERICA_DENVER]: '(MT)',
  [AllowedTimezones.AMERICA_LOS_ANGELES]: '(PT)',
  [AllowedTimezones.AMERICA_PHOENIX]: '(MT)',
};

export function useContractorDateWithTimeZone() {
  const { data } = useGetContractor();
  const timezone = data?.data.timezone ?? getTimezone();
  const isContractor = data?.data.paymentMethod;

  return function getPending(date: string): string {
    const formDate = isContractor ? getPendingDate(date) : getFormattedDate(date);
    const isInvalid = formDate.includes('invaliddate') || formDate.includes('undefined');

    const pendingDate = isInvalid ? date : formDate;

    return isContractor ? `${pendingDate} ${timeZonesLegends[timezone]}` : `${getDayName(date)}, ${pendingDate}`;
  };
}
